<template>
  <div>
    <el-upload
      v-bind="$attrs"
      :action="action"
      list-type="picture"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-exceed="handleExceed"
      :data="formData"
      show-file-list
      :limit="1"
      :file-list="internalFileList"
      :auto-upload="true">
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
    </el-upload>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  // model: {
  //   prop: 'value',
  //   event: 'change',
  // },
  props: {
    fileList: {
      type: [Array, String],
      default() {return []}
    }
  },
  data() {
    return {
      action:'',
      formData: {
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: "200",
        signature: '',
      },
      internalFileList: []
    };
  },

  watch: {
    fileList: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (typeof newVal === 'string') {
          // If it's a string, convert to array format
          this.internalFileList = [{ name: newVal.split('/').pop(), url: newVal }];
        } else if (Array.isArray(newVal)) {
          // If it's already an array, use it directly
          this.internalFileList = newVal;
        } else {
          // Default to empty array
          this.internalFileList = [];
        }
      }
    }
  },

  methods: {
    async beforeUpload(file) {
     try {
       const res = await request({
         url: 'ossapi.yy',
         method: 'get',
       })
         const {accessid: OSSAccessKeyId, host, policy, dir, signature,callback} = res.data;
         this.formData = {
           key: `${dir}/${file.name}`,
           callback,
           policy,
           OSSAccessKeyId,
           signature,
           success_action_status: '200'
         }
         this.action = host
       return true;
     }catch (error) {
       console.log(error)
       return false;
     }
    },
    handleExceed(files, fileList) {
      this.$message.warning(`只能上传 1 个文件，请先删除当前文件`);
    },
    handleSuccess(response, file, fileList){
      //暂无用到
      this.internalFileList = [{name: response.data.filename, url:response.url}]
      this.$emit('uploadChange', this.internalFileList);
    },
  }
}
</script>
